// Treasury → Fees — section layout.
//
// The fee tooling is a sidebar group with one page per job:
//
//   /treasury/fees/policies   the resolution chain (default → overrides)
//   /treasury/fees/users      per-user special fees
//   /treasury/fees/activity   the full audit trail
//
// This file only mounts the children; /treasury/fees itself redirects
// to the Policies page (see treasury.fees.index.tsx) so old bookmarks
// keep working.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/treasury/fees")({
  component: Outlet,
});
